export const ageOptions = [
  { id: '1', value: '5', label: '5' },
  { id: '2', value: '6', label: '6' },
  { id: '3', value: '7', label: '7' },
  { id: '4', value: '8', label: '8' },
  { id: '5', value: '9', label: '9' },
  { id: '6', value: '10', label: '10' },
  { id: '7', value: '11', label: '11' },
  { id: '8', value: '12', label: '12' },
  { id: '9', value: '13', label: '13' },
  { id: '10', value: '14', label: '14' },
  { id: '11', value: '15', label: '15' },
  { id: '12', value: '16', label: '16' },
  { id: '13', value: '17', label: '17' },
  { id: '14', value: '18+', label: '18+' },
];

export const affiliateAgeOptions = Array.from({ length: 70 }, (_, i) => ({
  id: (i + 15).toString(),
  value: (i + 15).toString(),
  label: (i + 15).toString(),
}));

export const genderOptions = [
  { id: '1', value: 'male', label: 'Male' },
  { id: '2', value: 'female', label: 'Female' },
  { id: '3', value: 'transgender', label: 'Transgender' },
  {
    id: '4',
    value: 'non-binary/non-conforming',
    label: 'Non-Binary/Non-Conforming',
  },
  { id: '5', value: 'prefer not to respond', label: 'Prefer not to respond' },
];

export const subscriptionOptions = [
  { id: '1', value: 'free trial', label: 'Free Trial' },
  { id: '2', value: 'annual', label: 'Annual' },
  { id: '3', value: 'two year', label: 'Two Year' },
];

export const businessOptions = [
  { id: '1', value: 'individual', label: 'Individual' },
  { id: '2', value: 'business', label: 'Business' },
];

export const referralSourceOptions = [
  { id: 'google', value: 'google', label: 'Google/Search' },
  { id: 'facebook', value: 'facebook', label: 'Facebook' },
  { id: 'instagram', value: 'instagram', label: 'Instagram' },
  { id: 'twitter', value: 'twitter', label: 'X (formerly Twitter)' },
  { id: 'youtube', value: 'youtube', label: 'YouTube' },
  { id: 'referral', value: 'referral', label: 'Referral' },
  { id: 'pta_school', value: 'pta_school', label: 'PTA or School Event' },
  {
    id: 'coding_class',
    value: 'coding_class',
    label: 'In-Person Coding Class or Bootcamp',
  },
  { id: 'newsletter', value: 'newsletter', label: 'Newsletter or Blog Post' },
  {
    id: 'online_forum',
    value: 'online_forum',
    label: 'Online Forum (e.g. Reddit)',
  },
  { id: 'tiktok', value: 'tiktok', label: 'TikTok' },
  { id: 'other', value: 'other', label: 'Other (please specify)' },
];
